import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FeaturedPost = ({ post, loading }) => {
  if (loading) {
    return (
      <section className="bg-background pt-8 pb-16 border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12 animate-pulse">
            <div className="h-10 bg-white/10 w-64 mx-auto rounded mb-4"></div>
            <div className="h-5 bg-white/10 w-96 mx-auto rounded"></div>
          </div>

          <div className="w-full mx-auto animate-pulse">
            <article className="bg-white/5 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
              <div className="lg:flex">
                <div className="lg:w-1/2">
                  <div className="h-64 lg:h-[400px] bg-white/10"></div>
                </div>
                <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center space-y-4">
                  <div className="flex gap-4 mb-4">
                    <div className="w-24 h-6 bg-white/10 rounded-full"></div>
                    <div className="w-24 h-6 bg-white/10 rounded-full"></div>
                  </div>
                  <div className="h-8 bg-white/10 rounded w-full"></div>
                  <div className="h-8 bg-white/10 rounded w-3/4 mb-4"></div>
                  <div className="h-4 bg-white/10 rounded w-full"></div>
                  <div className="h-4 bg-white/10 rounded w-full"></div>
                  <div className="h-4 bg-white/10 rounded w-2/3 mb-6"></div>
                  <div className="flex items-center gap-4 text-sm text-text-muted mb-6">
                     <div className="w-16 h-4 bg-white/10 rounded"></div>
                     <div className="w-16 h-4 bg-white/10 rounded"></div>
                     <div className="w-16 h-4 bg-white/10 rounded"></div>
                  </div>
                  <div className="w-40 h-12 bg-white/10 rounded-lg mt-2"></div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    );
  }

  if (!post) return null; 
  return (
    <section className="bg-background pt-8 pb-16 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Featured Article
          </h2>
          <p className="font-body text-lg text-text-secondary max-w-2xl mx-auto">
            Our most popular and impactful piece, offering deep insights into professional practice.
          </p>
        </div>

        <div className="w-full mx-auto">
          <article className="bg-white/5 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/10 shadow-2xl hover:shadow-accent/5 transition-smooth">
            <div className="lg:flex">
              {/* Image */}
              <div className="lg:w-1/2">
                <div className="h-64 lg:h-full overflow-hidden">
                  <Image
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-smooth duration-700"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-4 mb-4">
                  <span className="bg-accent/10 text-accent px-3 py-1 rounded-full text-sm font-medium">
                    {post.category}
                  </span>
                  <span className="bg-success/10 text-success px-3 py-1 rounded-full text-sm font-medium flex items-center gap-1">
                    <Icon name="Star" size={14} />
                    Featured
                  </span>
                </div>

                <h3 className="font-heading text-2xl lg:text-3xl font-bold text-text-primary mb-4 leading-tight">
                  {post.title}
                </h3>

                <p className="font-body text-text-secondary mb-6 leading-relaxed">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-4 text-sm text-text-muted">
                    <div className="flex items-center gap-1">
                      <Icon name="Calendar" size={16} />
                      <span>{post.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Clock" size={16} />
                      <span>{post.readTime}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Eye" size={16} />
                      <span>{post.views || 0}</span>
                    </div>
                  </div>
                </div>


                <Link
                  to={`/blog/${post.slug || post.id}`}
                  className="inline-flex items-center gap-2 bg-primary hover:bg-primary-700 text-white font-heading font-semibold px-6 py-3 rounded-lg transition-smooth group"
                  aria-label={`Read the full featured article: ${post.title}`}
                  title={post.title}
                >
                  Read Full Article
                  <Icon name="ArrowRight" size={18} className="group-hover:translate-x-1 transition-smooth" />
                </Link>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPost;